/* SpawnAnything — dice roll (pure, shared by src/features/dice.js and the tests). */
const POINTS = [600, 1200, 2500, 5000];
const MAX_UNITS = 2500; // per side

/** Two different types with about the same points (at least 3 units of the dearer one); null when fewer than 2 types.
    Returns writeCfg rows [[type, count, weapon, size], [...]]. */
export function rollArmies(types, cost, allowType, rng = Math.random) {
  const keys = Object.keys(types).filter(k => allowType(k) && cost(k) > 0);
  if (keys.length < 2) return null;
  const a = keys[Math.floor(rng() * keys.length)];
  let b = a; for (let i = 0; i < 20 && b === a; i++) b = keys[Math.floor(rng() * keys.length)];
  if (b === a) return null;
  const ca = cost(a), cb = cost(b);
  const P = Math.max(POINTS[Math.floor(rng() * POINTS.length)], 3 * Math.max(ca, cb));
  const n = c => Math.max(1, Math.min(MAX_UNITS, Math.round(P / c)));
  return [[a, n(ca), types[a].weapon, 1], [b, n(cb), types[b].weapon, 1]];
}
